module.exports = __webpack_public_path__ + "images/bannerEN-bea026131c7220d1ec1790f06591bba6.jpg";